import { render, staticRenderFns } from "./cityNumber.vue?vue&type=template&id=0abb52c9&scoped=true"
import script from "./cityNumber.vue?vue&type=script&lang=js"
export * from "./cityNumber.vue?vue&type=script&lang=js"
import style0 from "./cityNumber.vue?vue&type=style&index=0&id=0abb52c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb52c9",
  null
  
)

export default component.exports